var map = {
	"./nav-acts.svg": "cf85",
	"./nav-archive.svg": "bd20",
	"./nav-back.svg": "4f65",
	"./nav-cleaning_journals.svg": "48b6",
	"./nav-covid-dark.svg": "a70d",
	"./nav-covid-light.svg": "c414",
	"./nav-dashboards.svg": "9b1f",
	"./nav-dynamic_issues.svg": "562d",
	"./nav-expenses.svg": "8021",
	"./nav-instructions.svg": "426c",
	"./nav-issue_center.svg": "30ec",
	"./nav-issues.svg": "d361",
	"./nav-logo.svg": "1a54",
	"./nav-map.svg": "f542",
	"./nav-measuring.svg": "ba6e",
	"./nav-ppr.svg": "d9db",
	"./nav-public_request.svg": "6499",
	"./nav-reference.svg": "e67b",
	"./nav-search.svg": "484f",
	"./nav-settings.svg": "b48c",
	"./nav-signout.svg": "51c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b1c";